import {Component, inject, OnInit} from '@angular/core';
import {MatDivider} from '@angular/material/divider';
import {MatIcon} from '@angular/material/icon';
import {ActivatedRoute, Router} from '@angular/router';
import {Kits} from '@interfaces/kits';
import {DoctorsService} from '@services/doctors/doctors.service';
import {MatProgressBar} from '@angular/material/progress-bar';
import {DatePipe} from '@angular/common';

@Component({
  selector: 'app-patient-kits',
  imports: [
    MatDivider,
    MatIcon,
    MatProgressBar,
    DatePipe
  ],
  templateUrl: './patient-kits.component.html',
  styleUrl: './patient-kits.component.scss'
})
export class PatientKitsComponent implements OnInit {

  kits?: Kits[];

  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private doctorService = inject(DoctorsService);

  constructor() {
    this.route.paramMap.subscribe(params => {
      const doctorId = params.get('doctorId') ?? '';
      const patientId = params.get('patientId') ?? '';
      this.loadKits(doctorId, patientId);
    });
  }


  goBack() {
    this.router.navigate(['..'], {relativeTo: this.route});
  }

  ngOnInit() {

  }

  loadKits(doctorId: string, patientId: string) {
    this.doctorService.fetchKits(patientId).subscribe({
      next: (data: any) => {
        this.kits = data;
        this.doctorService.kitsList.next(data);
      },
      error: (error: any) => {
        console.error('Error fetching kits', error);
      }
    });
  }

  openKits(kit: Kits) {

  }
}
